import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { fromEventPattern, map, Observable, startWith } from 'rxjs';
import { FilterQueryModel } from 'src/app/models/filter-query-model';
import { userResponse } from 'src/app/models/estados';
import { EstadoNegoEnum } from 'src/app/models/enums/estado-nego-enum';
import { CSVQueryModel } from 'src/app/models/csv-query-model';
import {NegosService} from "../../../core/negos/negos.service";
import { GoogleAuthenticationService } from 'src/app/core/login/google-authentication.service';
import { OauthService } from 'src/app/core/oauth/oauth.service';

@Component({
  standalone: false,
  selector: 'app-negos-search-form',
  templateUrl: './negos-search-form.component.html',
  styleUrls: ['./negos-search-form.component.scss']
})
export class NegosSearchFormComponent implements OnInit {

  @Input() showPNRFilter: boolean = true;
  @Input() estados: any[];
  
  @Output() getDataFilter = new EventEmitter<FilterQueryModel>();
  @Output() getDataCSVFilter = new EventEmitter<CSVQueryModel>();

  @Input() isValidateOneOption: boolean = false;

  isLoadingResults: boolean = false;

  configControls: {[key: string]: any;} = {
    dateFrom: [
      null,
      []
    ],
    dateTo: [
      null,
      []
    ],
    processDateFrom: [
      null,
      []
    ],
    processDateTo: [
      null, []
    ],
    applicationUser: [
      '', [this.validateObjectOption]
    ],
    status: [
      '', []
    ],
    cuenta: [
      '', []
    ],
    
  }

  FORMAT_DATE = "YYYY-MM-DD";
  form: FormGroup;

  consulta = new FilterQueryModel();
  solicitantes = new Array<userResponse>();

  filteredOptions: Observable<userResponse[]>;

  rol: string | null;
  user: any;

  emailUser: string = '';

  constructor(private negosService: NegosService,
              private formBuilder: FormBuilder,
              private googleAuthenticationService: GoogleAuthenticationService,
              private _oauthService: OauthService) {}

  ngOnInit(): void {

    this.isLoadingResults = true;
    this._oauthService.aoutUser().subscribe( roles => {
      this.rol = roles.roles[0];
      this.isLoadingResults = false;
    })

    this.user = this.googleAuthenticationService.getSocialUser;
    if(this.user){
      this.emailUser = this.user.email;
    }

    this.listUserEstados();

    if(this.showPNRFilter){
      this.configControls['pnr'] = ['', []];
    }
    
    this.form = this.formBuilder.group(this.configControls);

    if(this.isValidateOneOption){
      this.form.setValidators(this.validateOneOptionRequired);
    }

    let inputSolicitante = this.form.get('applicationUser');

    if(inputSolicitante){
      this.filteredOptions = inputSolicitante.valueChanges.pipe(
        startWith(''),
        map((value: string) => this._filter(value))
      )
    }
  }

  listUserEstados() {
    this.negosService.getUserEstados().subscribe((res: any) => {
    this.solicitantes = res;
    });
  }

  sendRequest(){
    let data = this.form.value;

    data.solicitante = { 'usuario': this.emailUser };

    let filterQueryModel: FilterQueryModel = {
      dateFrom: data.dateFrom?.format(this.FORMAT_DATE),
      dateTo: data.dateTo?.format(this.FORMAT_DATE),
      processDateFrom: data.processDateFrom?.format(this.FORMAT_DATE),
      processDateTo: data.processDateTo?.format(this.FORMAT_DATE),
      pnr: data.pnr,
      cuenta: data.cuenta,
      status: data.status,
      applicationUser: data.applicationUser?.usuario,
      profile: this.rol,
      user: data?.solicitante?.usuario
    }

    this.getDataFilter.emit(filterQueryModel);
  }

  sendRequestCSV(){
    let data = this.form.value;
    let csvQueryModel: CSVQueryModel = {
      dateFrom: data.dateFrom?.format(this.FORMAT_DATE),
      dateTo: data.dateTo?.format(this.FORMAT_DATE),
      processDateFrom: data.processDateFrom?.format(this.FORMAT_DATE),
      processDateTo: data.processDateTo?.format(this.FORMAT_DATE),
      status: data.status,
      cuenta: data.cuenta,
      pnr: data.pnr,
      applicationUser: data.applicationUser?.usuario,
      profile: this.rol,
      user: this.emailUser
    }

    this.getDataCSVFilter.emit(csvQueryModel);
  }

  private _filter(value: string): userResponse[] {

    if(typeof(value) != "string") return [];

    const filterValue = value.toLowerCase();
    return this.solicitantes.filter( ({ usuario }) => usuario.toLowerCase().includes(filterValue));
  }

  validateObjectOption(form: FormGroup){
    return typeof(form.value) == "string" && form.value.length > 0 ? {invalidOption: true}:{}
  }

  validateOneOptionRequired(formGroup: AbstractControl): ValidationErrors | null  {
    const objectForm = formGroup.value;

    for( let key of Object.keys(objectForm)){
      if(objectForm[key]){
        return null;
      }
    }
    return {invalid: true}
  }

  getOptionText(option: userResponse){
    return option?.usuario;
  }
}
